function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from 'react';
import { Severity } from '@sentry/react';
import { useRequest, useMemoizedFn } from 'ahooks';
import { isEmpty } from 'lodash';
import { SLModal } from '@yy/sl-admin-components';
import { ECancelPayStrategy } from '../types';
import { ErrorPrefixKey, EPayMethodType, EBeforePayStatus, ECreateSubStatus, EBPayStatus, ESubType, EChannelId, EBillStatus, EValidationNode, RedirectAction, ProductId, ChannelIdMap, PaymentMethodMap, DefaultSDKCurrency, ActionType, PayErrorMap, APIResponseCode, RadioPayMethod } from '../constants';
import { useConfigAtom, useDataAtom, useDataAtomValues, useStateAtom } from '../state';
import { useEventAtom, EEvent } from '../events';
import useBeforePay from './useBeforePay';
import usePayment from './usePayment';
import usePayChannelId from './usePayChannelId';
import usePayMerchantInfo from './usePayMerchantInfo';
import useComputedBuyNum from './useComputedBuyNum';
import useResetState from './useResetState';
import { postSubCreate, getBillStatus, postCreditQuickPay, postHuifuPay, getBillCancel, getPayChannelStatus, EPayChannel, postCancelPay } from '../services';
import { catchWith, isLaxNull, getI18nErrMsg } from '../_utils/tool';
import { useTranslation } from '../_utils/i18n';
import usePayWithPayPal from '../hooks/usePayPalHandler';
export default function usePayHandler() {
  var _useConfigAtom = useConfigAtom(),
    _useConfigAtom2 = _slicedToArray(_useConfigAtom, 2),
    _useConfigAtom2$ = _useConfigAtom2[0],
    billId = _useConfigAtom2$.billId,
    appId = _useConfigAtom2$.appId,
    subId = _useConfigAtom2$.subId,
    spuId = _useConfigAtom2$.spuId,
    _useConfigAtom2$$prod = _useConfigAtom2$.productId,
    productId = _useConfigAtom2$$prod === void 0 ? ProductId : _useConfigAtom2$$prod,
    countryCode = _useConfigAtom2$.countryCode,
    productRegion = _useConfigAtom2$.productRegion,
    merchantNo = _useConfigAtom2$.merchantNo,
    phone = _useConfigAtom2$.phone,
    email = _useConfigAtom2$.email,
    paymentName = _useConfigAtom2$.paymentName,
    paymentID = _useConfigAtom2$.paymentID,
    bizType = _useConfigAtom2$.bizType,
    subBizType = _useConfigAtom2$.subBizType,
    bizCreateSub = _useConfigAtom2$.bizCreateSub,
    priceCurrencyCode = _useConfigAtom2$.priceCurrencyCode,
    curBillId = _useConfigAtom2$.billId,
    curSkuId = _useConfigAtom2$.skuId,
    _useConfigAtom2$$subT = _useConfigAtom2$.subType,
    subType = _useConfigAtom2$$subT === void 0 ? ESubType.paid : _useConfigAtom2$$subT,
    returnUrl = _useConfigAtom2$.returnUrl,
    onBeforePay = _useConfigAtom2$.onBeforePay,
    onCreateSubError = _useConfigAtom2$.onCreateSubError,
    onSuccess = _useConfigAtom2$.onSuccess,
    onError = _useConfigAtom2$.onError,
    onCancelPay = _useConfigAtom2$.onCancelPay,
    onPayCancel = _useConfigAtom2$.onPayCancel,
    cancelPayStrategy = _useConfigAtom2$.cancelPayStrategy,
    theme = _useConfigAtom2$.theme,
    sentryHub = _useConfigAtom2$.sentryHub,
    upgradeType = _useConfigAtom2$.upgradeType,
    bizOwnerNo = _useConfigAtom2$.bizOwnerNo,
    bizOrderNo = _useConfigAtom2$.bizOrderNo,
    bizReturnUrl = _useConfigAtom2$.bizReturnUrl,
    bizOneShipPay = _useConfigAtom2$.bizOneShipPay,
    renderConfirmPendingBill = _useConfigAtom2$.renderConfirmPendingBill,
    setConfigAtom = _useConfigAtom2[1];
  // bizType有值，则代表主站，基参需要保留；bizType没值，则代表非主站，基参不需要再传
  var baseReqParams = React.useMemo(function () {
    return bizType === 'SHOPLINE' ? {
      appId: appId,
      bizType: bizType,
      subBizType: subBizType
    } : {};
  }, [appId, bizType, subBizType]);
  var dataAtom = useDataAtomValues();
  var _useDataAtom = useDataAtom(),
    _useDataAtom2 = _slicedToArray(_useDataAtom, 2),
    _useDataAtom2$ = _useDataAtom2[0],
    billDetail = _useDataAtom2$.billDetail,
    productInfo = _useDataAtom2$.productInfo,
    promotion = _useDataAtom2$.appledSuccessPromotionInfo,
    setDataAtom = _useDataAtom2[1];
  var _useStateAtom = useStateAtom(),
    _useStateAtom2 = _slicedToArray(_useStateAtom, 2),
    _useStateAtom2$ = _useStateAtom2[0],
    curPayMethod = _useStateAtom2$.payMethod,
    selectCard = _useStateAtom2$.selectCard,
    radioPayMethod = _useStateAtom2$.radioPayMethod,
    setStateAtom = _useStateAtom2[1];
  var _useEventAtom = useEventAtom(),
    event$ = _useEventAtom.event$;
  var handlePayPal = usePayWithPayPal(_objectSpread(_objectSpread({}, baseReqParams), {}, {
    billId: billId,
    countryCode: countryCode,
    phone: phone,
    email: email,
    onSuccess: onSuccess,
    payMethod: curPayMethod
  }));
  var useBeforePayReturns = useBeforePay();
  var _usePayChannelId = usePayChannelId(),
    channelId = _usePayChannelId.channelId;
  // 获取支付商家信息
  var usePayMerchantInfoReturns = usePayMerchantInfo({
    payChannel: EChannelId[channelId]
  }, {
    manual: true
  });
  var reset = useResetState();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var computedBuyNum = useComputedBuyNum();
  var handlePaySuccess = useMemoizedFn(function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // eslint-disable-next-line no-console
    console.log("\u652F\u4ED8\u6210\u529F\uFF0C\u6267\u884C\u94A9\u5B50\u51FD\u6570\uFF1AonSuccess");
    if ([EBillStatus.CANCELED, EBillStatus.UNPAID].includes(dataAtom.billStatus)) {
      // 第二个参数是给订阅子应用使用的
      onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess({
        billId: data.billId || curBillId,
        payMethod: curPayMethod
      }, true);
    } else {
      onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess({
        billId: data.billId || curBillId,
        payMethod: curPayMethod
      }, false);
    }
    reset();
  });
  var _useRequest = useRequest(getBillStatus, {
      manual: true,
      pollingInterval: 1000,
      onSuccess: function onSuccess(res) {
        var _res$data;
        if ((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.status) === EBillStatus.PAYED) {
          cancelQueryBillStatus();
          handlePaySuccess();
        }
      },
      onError: function onError(err, params) {
        var _params$;
        cancelQueryBillStatus();
        handlePayError({
          code: err === null || err === void 0 ? void 0 : err.code,
          msg: err === null || err === void 0 ? void 0 : err.msg,
          billId: params === null || params === void 0 ? void 0 : (_params$ = params[0]) === null || _params$ === void 0 ? void 0 : _params$.billId
        });
      }
    }),
    queryBillStatus = _useRequest.run,
    cancelQueryBillStatus = _useRequest.cancel;
  var _useRequest2 = useRequest(getPayChannelStatus, {
      manual: true,
      pollingInterval: 1000,
      onSuccess: function onSuccess(res) {
        var _ref = (res === null || res === void 0 ? void 0 : res.data) || {},
          status = _ref.status,
          payErrorCode = _ref.payErrorCode,
          payErrorMsg = _ref.payErrorMsg;
        if (status === EPayChannel.SUCCESS) {
          cancelQueryPayChannelStatus();
          handlePaySuccess();
        }
        if (status === EPayChannel.FAILED) {
          cancelQueryPayChannelStatus();
          handlePayError({
            code: payErrorCode,
            msg: getI18nErrMsg('payError', payErrorCode) || payErrorMsg,
            billId: curBillId
          });
          setStateAtom(function (draft) {
            draft.payLoading = false;
          });

          // 支付失败后重置账单状态为待支付
          setDataAtom(function (draft) {
            draft.isBillPending = false;
            draft.billStatus = EBillStatus.UNPAID;
          });
        }
      },
      onError: function onError(err) {
        cancelQueryPayChannelStatus();
        handlePayError({
          code: err === null || err === void 0 ? void 0 : err.code,
          msg: getI18nErrMsg('payError', err === null || err === void 0 ? void 0 : err.code) || (err === null || err === void 0 ? void 0 : err.msg),
          billId: curBillId
        });
      }
    }),
    queryPayChannelStatus = _useRequest2.run,
    cancelQueryPayChannelStatus = _useRequest2.cancel;
  var handlePayError = useMemoizedFn(function (data) {
    // 账单已取消
    if (data.code === 'TCBI0121') {
      setDataAtom(function (draft) {
        draft.billStatus = EBillStatus.CANCELED;
      });
    }

    // 账单已经支付
    if (data.code === 'TCBI0120') {
      setDataAtom(function (draft) {
        draft.billStatus = EBillStatus.PAYED;
      });
    }
    sentryHub === null || sentryHub === void 0 ? void 0 : sentryHub.captureException(new Error('Settlement SDK onError'), {
      captureContext: {
        tags: {
          errCode: data === null || data === void 0 ? void 0 : data.code
        },
        contexts: {
          info: {
            errorInfo: JSON.stringify(data)
          }
        },
        level: Severity.Error
      }
    });
    console.error('支付失败, 执行钩子函数：onError', data);
    onError === null || onError === void 0 ? void 0 : onError(data);
    reset({
      resetBillId: false
    });
  });
  var handlePayCancel = useMemoizedFn( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _cancelRst, _cancelRst$data, _cancelRst2, _cancelRst2$data;
    var options,
      _options$invokeCancel,
      invokeCancelApi,
      cancelRst,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            _options$invokeCancel = options.invokeCancelApi, invokeCancelApi = _options$invokeCancel === void 0 ? true : _options$invokeCancel; // 调用取消接口的返回结果
            if (!(onCancelPay !== null && onCancelPay !== void 0 && onCancelPay.cancel)) {
              _context.next = 8;
              break;
            }
            // eslint-disable-next-line no-console
            console.log('取消支付, 执行钩子函数：onCancelPay.cancel');
            _context.next = 6;
            return onCancelPay.cancel({
              billId: billId,
              payMethod: curPayMethod
            });
          case 6:
            _context.next = 18;
            break;
          case 8:
            if (!invokeCancelApi) {
              _context.next = 18;
              break;
            }
            if (!(cancelPayStrategy === ECancelPayStrategy.onlyPay)) {
              _context.next = 15;
              break;
            }
            _context.next = 12;
            return catchWith(postCancelPay(_objectSpread(_objectSpread({}, baseReqParams), {}, {
              billId: billId
            })));
          case 12:
            cancelRst = _context.sent;
            _context.next = 18;
            break;
          case 15:
            _context.next = 17;
            return catchWith(getBillCancel(_objectSpread(_objectSpread({}, baseReqParams), {}, {
              billId: billId
            })));
          case 17:
            cancelRst = _context.sent;
          case 18:
            if (onCancelPay !== null && onCancelPay !== void 0 && onCancelPay.after) {
              // eslint-disable-next-line no-console
              console.log('取消支付之后, 执行钩子函数：onCancelPay.after');
              onCancelPay.after({
                billId: billId,
                payMethod: curPayMethod
              });
            }
            // NOTE: 兼容之前的API,后续版本即将废弃，由 onCancelPay.after 替代
            else if (onPayCancel) {
              // eslint-disable-next-line no-console
              console.log('取消支付之后, 执行钩子函数：onPayCancel');
              onPayCancel({
                billId: billId,
                payMethod: curPayMethod
              });
            }

            // 如果取消账单的接口成功，则需要重置billId
            reset({
              resetBillId: !!((_cancelRst = cancelRst) !== null && _cancelRst !== void 0 && (_cancelRst$data = _cancelRst.data) !== null && _cancelRst$data !== void 0 && _cancelRst$data.success) && ((_cancelRst2 = cancelRst) === null || _cancelRst2 === void 0 ? void 0 : (_cancelRst2$data = _cancelRst2.data) === null || _cancelRst2$data === void 0 ? void 0 : _cancelRst2$data.code) === APIResponseCode.SUCCESS
            });
          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })));

  // 查询账单状态

  // 结算页初始化payment：用于新支付方式-汇付
  var _usePayment = usePayment('', _objectSpread(_objectSpread({}, baseReqParams), {}, {
      region: countryCode,
      payChannel: channelId === EChannelId.wechat ? EChannelId.stripe : EChannelId[channelId]
    })),
    payment = _usePayment.payment,
    setInitData = _usePayment.setInitData;
  var setSDKInitData = useMemoizedFn( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var data, paymentMethod;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (![EPayMethodType.Wechat, EPayMethodType.Creditcard, EPayMethodType.FPX, EPayMethodType.XENDIT, EPayMethodType.PayNow, EPayMethodType.PayPal].includes(curPayMethod)) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            _context2.next = 4;
            return usePayMerchantInfoReturns.getter();
          case 4:
            data = _context2.sent;
            paymentMethod = PaymentMethodMap[curPayMethod];
            if (!isEmpty(data) && paymentMethod) {
              setInitData({
                countryCode: countryCode,
                currency: (billDetail === null || billDetail === void 0 ? void 0 : billDetail.orderCurrency) || DefaultSDKCurrency,
                paymentMethod: PaymentMethodMap[curPayMethod],
                channelId: ChannelIdMap[channelId],
                isBindCard: false,
                merchantId: data === null || data === void 0 ? void 0 : data.payMerchantId,
                theme: {
                  CreditCard: {
                    inputFocusBorderColor: theme.highlightColor
                  }
                }
              });
            }
          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })));

  // 初始化交易SDK
  React.useEffect(function () {
    setSDKInitData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billDetail === null || billDetail === void 0 ? void 0 : billDetail.orderCurrency, curPayMethod]);

  // 调用创建账单的接口
  var invokeCreateSubApi = function invokeCreateSubApi() {
    // 调用业务方传入的自定义创单函数
    if (bizCreateSub) {
      return bizCreateSub({
        skuId: curSkuId,
        promotion: promotion,
        buyNum: computedBuyNum
      });
    } else {
      return postSubCreate(_objectSpread(_objectSpread({}, baseReqParams), {}, {
        // merchantNo,
        subId: subId,
        spuId: spuId,
        skuId: curSkuId,
        currency: priceCurrencyCode,
        region: productRegion || countryCode,
        promotion: promotion,
        subType: subType,
        extUserId: merchantNo,
        buyNum: computedBuyNum,
        upgradeType: upgradeType,
        bizOwnerNo: bizOwnerNo,
        bizOrderNo: bizOrderNo,
        returnUrl: bizReturnUrl
      })).then(function (res) {
        return res.data;
      });
    }
  };

  /**
   * 创建账单的动作，需要进行创建操作的地方如下：
   * 1.点击去支付的时候，如果没有billId，需要先创建账单
   * 2.点击绑卡并支付按钮的时候，如果没有billId，需要先创建账单
   */

  // 不是reaction
  // 依赖：billId, isBillIdByCreateSub, payLoading; success后 reset jotai
  var createSub = useMemoizedFn( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var billIdFromResponse, _createSubRst$data, _createSubRst$data3, createSubRst, _createSubRst$data2, _createSubRst$error, _createSubRst$error2;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            // 如果没有billId，表明需要在结算页进行下单
            billIdFromResponse = curBillId;
            if (billIdFromResponse) {
              _context3.next = 18;
              break;
            }
            _context3.next = 4;
            return catchWith(
            // 调接口，不同步数据到jotai
            invokeCreateSubApi());
          case 4:
            createSubRst = _context3.sent;
            if (isLaxNull((_createSubRst$data = createSubRst.data) === null || _createSubRst$data === void 0 ? void 0 : _createSubRst$data.billId)) {
              _context3.next = 13;
              break;
            }
            billIdFromResponse = (_createSubRst$data2 = createSubRst.data) === null || _createSubRst$data2 === void 0 ? void 0 : _createSubRst$data2.billId;
            setConfigAtom(function (draft) {
              draft.billId = billIdFromResponse;
            });
            // 设置下单获取到billId的标志位
            setStateAtom(function (draft) {
              draft.isBillIdByCreateSub = true;
            });
            // 如果实付金额为0，则不需要拉起支付流程，后端接口会异步将账单设置为“已支付”
            // 物流钱包支付也必须要拉起bizOneShipPay调用，才能轮询支付状态；https://shopline.yuque.com/rp76um/aotkvi/ytap43kzf8uwcwlc
            if (!((billDetail === null || billDetail === void 0 ? void 0 : billDetail.settleAmount) === 0 && curPayMethod !== EPayMethodType.OneShip)) {
              _context3.next = 12;
              break;
            }
            queryBillStatus(_objectSpread(_objectSpread({}, baseReqParams), {}, {
              billId: billIdFromResponse
            }));
            return _context3.abrupt("return", ECreateSubStatus.BREAK);
          case 12:
            return _context3.abrupt("return", billIdFromResponse);
          case 13:
            if (!(!((_createSubRst$data3 = createSubRst.data) !== null && _createSubRst$data3 !== void 0 && _createSubRst$data3.billId) || createSubRst.error)) {
              _context3.next = 18;
              break;
            }
            setStateAtom(function (draft) {
              draft.payLoading = false;
            });
            console.error('下单失败, 执行钩子函数：onCreateSubError', createSubRst.error);
            onCreateSubError === null || onCreateSubError === void 0 ? void 0 : onCreateSubError({
              code: (_createSubRst$error = createSubRst.error) === null || _createSubRst$error === void 0 ? void 0 : _createSubRst$error.code,
              msg: (_createSubRst$error2 = createSubRst.error) === null || _createSubRst$error2 === void 0 ? void 0 : _createSubRst$error2.msg
            });
            return _context3.abrupt("return", ECreateSubStatus.FAIL);
          case 18:
            return _context3.abrupt("return", billIdFromResponse);
          case 19:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })));

  // 绑卡快捷支付执行函数
  var quickPay = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(createSubResult) {
      var payMerchantInfo;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return usePayMerchantInfoReturns.getter();
            case 2:
              payMerchantInfo = _context4.sent;
              postCreditQuickPay(_objectSpread(_objectSpread({}, baseReqParams), {}, {
                merchantNo: merchantNo,
                bindUniqueId: selectCard.bindUniqueId,
                billId: createSubResult,
                channelAppId: payMerchantInfo.payMerchantId
              })).then(function (res) {
                var _ref6 = (res === null || res === void 0 ? void 0 : res.data) || {},
                  payStatus = _ref6.payStatus,
                  errorCode = _ref6.errorCode;
                if (!isLaxNull(payStatus) && payStatus !== EBPayStatus.FAILED) {
                  handlePaySuccess({
                    billId: createSubResult
                  });
                } else {
                  return Promise.reject({
                    code: errorCode
                  });
                }
              }).catch(function (err) {
                console.error('信用卡快捷支付失败, 执行钩子函数：onError', err);
                handlePayError({
                  code: err === null || err === void 0 ? void 0 : err.code,
                  msg: getI18nErrMsg(ErrorPrefixKey, (err === null || err === void 0 ? void 0 : err.code) || 'other') || getI18nErrMsg(ErrorPrefixKey, 'other'),
                  billId: createSubResult
                });
              }).finally(function () {
                setStateAtom(function (draft) {
                  draft.payLoading = false;
                });
              });
            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return function quickPay(_x) {
      return _ref5.apply(this, arguments);
    };
  }();
  var handleHuifuPay = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(billId, payMethod, redirectAction) {
      var res, _data, nextAction, error, errCode;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return postHuifuPay(_objectSpread(_objectSpread({}, baseReqParams), {}, {
                // merchantNo,
                returnUrl: returnUrl,
                billId: billId,
                phone: phone,
                email: email,
                region: countryCode,
                paymentMethod: PaymentMethodMap[payMethod],
                productId: productId,
                paymentName: paymentName,
                paymentID: paymentID
              }));
            case 3:
              res = _context7.sent;
              _data = res.data; // eslint-disable-next-line no-console
              console.log('接口返回数据', _data);

              // 如果支付中台报错时
              if (!(_data !== null && _data !== void 0 && _data.payStatus && (_data === null || _data === void 0 ? void 0 : _data.payStatus) === EBPayStatus.FAILED)) {
                _context7.next = 11;
                break;
              }
              handlePayError({
                code: _data === null || _data === void 0 ? void 0 : _data.errorCode,
                msg: PayErrorMap[String(_data === null || _data === void 0 ? void 0 : _data.errorCode)] ? t("".concat(ErrorPrefixKey, ".").concat(_data === null || _data === void 0 ? void 0 : _data.errorCode)) : t("".concat(ErrorPrefixKey, ".other")),
                billId: curBillId
              });
              setStateAtom(function (draft) {
                draft.payLoading = false;
              });
              _context7.next = 20;
              break;
            case 11:
              nextAction = _data === null || _data === void 0 ? void 0 : _data.nextAction;
              if (!nextAction) {
                _context7.next = 19;
                break;
              }
              _context7.next = 15;
              return payment.pay(nextAction, {
                redirectAction: redirectAction
              });
            case 15:
              error = _context7.sent;
              // 如果成功调起支付，直接跳转 3d认证页面 or 2d支付成功跳转，是否走3d由渠道决策。
              // 否则，可以根据 error 处理错误返回
              if (error) {
                // eslint-disable-next-line no-console
                console.log('信用卡支付失败：', error);
                errCode = error === null || error === void 0 ? void 0 : error.paymentError.code;
                handlePayError({
                  code: errCode,
                  msg: PayErrorMap[String(errCode)] ? t("".concat(ErrorPrefixKey, ".").concat(errCode)) : t("".concat(ErrorPrefixKey, ".other")),
                  billId: curBillId
                });
                setStateAtom(function (draft) {
                  draft.payLoading = false;
                });
              } else {
                payMethod === EPayMethodType.HuifuChannelCasher && SLModal.confirm({
                  title: t('settlement.payway.UnionPayaggregation.box.title'),
                  okText: t('settlement.payway.UnionPayaggregation.box.note1'),
                  cancelText: t('settlement.payway.UnionPayaggregation.box.note2'),
                  onOk: function () {
                    var _onOk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
                      var notPayed;
                      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              _context5.next = 2;
                              return getNotPayedFlag();
                            case 2:
                              notPayed = _context5.sent;
                              onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess({
                                billId: _data === null || _data === void 0 ? void 0 : _data.billId,
                                payMethod: payMethod,
                                extInfo: {
                                  actionType: ActionType.Finish
                                }
                              }, notPayed);
                            case 4:
                            case "end":
                              return _context5.stop();
                          }
                        }
                      }, _callee5);
                    }));
                    function onOk() {
                      return _onOk.apply(this, arguments);
                    }
                    return onOk;
                  }(),
                  onCancel: function () {
                    var _onCancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
                      var notPayed;
                      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                        while (1) {
                          switch (_context6.prev = _context6.next) {
                            case 0:
                              _context6.next = 2;
                              return getNotPayedFlag();
                            case 2:
                              notPayed = _context6.sent;
                              onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess({
                                billId: _data === null || _data === void 0 ? void 0 : _data.billId,
                                payMethod: payMethod,
                                extInfo: {
                                  actionType: ActionType.Retry
                                }
                              }, notPayed);
                            case 4:
                            case "end":
                              return _context6.stop();
                          }
                        }
                      }, _callee6);
                    }));
                    function onCancel() {
                      return _onCancel.apply(this, arguments);
                    }
                    return onCancel;
                  }()
                });
                // SLMessage.success(I18n('bindSuccess'));
              }
              _context7.next = 20;
              break;
            case 19:
              if ((_data === null || _data === void 0 ? void 0 : _data.payStatus) === EBPayStatus.SUCCEEDED) {
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess({
                  billId: _data === null || _data === void 0 ? void 0 : _data.billId,
                  payMethod: payMethod
                });
              }
            case 20:
              _context7.next = 26;
              break;
            case 22:
              _context7.prev = 22;
              _context7.t0 = _context7["catch"](0);
              handlePayError({
                code: _context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.code,
                billId: curBillId
              });
              setStateAtom(function (draft) {
                draft.payLoading = false;
              });
            case 26:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[0, 22]]);
    }));
    return function handleHuifuPay(_x2, _x3, _x4) {
      return _ref7.apply(this, arguments);
    };
  }();
  var getNotPayedFlag = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      var _response$data;
      var billNotPayed, response, status;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              billNotPayed = true;
              _context8.next = 3;
              return getBillStatus(_objectSpread(_objectSpread({}, baseReqParams), {}, {
                // merchantNo,
                billId: curBillId
              }));
            case 3:
              response = _context8.sent;
              status = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.status; // billStatusFlag：true表示未支付成功
              if ([EBillStatus.CANCELED, EBillStatus.UNPAID].includes(status)) {
                billNotPayed = true;
              } else {
                billNotPayed = false;
              }
              return _context8.abrupt("return", billNotPayed);
            case 7:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));
    return function getNotPayedFlag() {
      return _ref8.apply(this, arguments);
    };
  }();

  // 若已有账单则直接支付、否则先下单再拉起支付
  var payHandler = useMemoizedFn( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    var _onBeforePay$validati, _onBeforePay$pendingB;
    var isValid, status, pendingBillData, createSubResult;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            setStateAtom(function (draft) {
              draft.payLoading = true;
            });
            isValid = true;
            status = EBeforePayStatus.continue; // 获取待支付的账单
            pendingBillData = null; // FPX结算类型需要发起校验
            if (!(curPayMethod === EPayMethodType.FPX)) {
              _context9.next = 11;
              break;
            }
            _context9.next = 7;
            return new Promise(function (resolve) {
              event$ === null || event$ === void 0 ? void 0 : event$.emit({
                type: EEvent.ON_PAY_VALIDATE_FPX,
                payload: {
                  resolve: resolve
                }
              });
            });
          case 7:
            isValid = _context9.sent;
            if (isValid) {
              _context9.next = 11;
              break;
            }
            reset({
              resetBillId: false
            });
            return _context9.abrupt("return");
          case 11:
            if (!(onBeforePay !== null && onBeforePay !== void 0 && (_onBeforePay$validati = onBeforePay.validation) !== null && _onBeforePay$validati !== void 0 && _onBeforePay$validati.handler)) {
              _context9.next = 18;
              break;
            }
            _context9.next = 14;
            return onBeforePay.validation.handler(EValidationNode.beforeCreateSub);
          case 14:
            isValid = _context9.sent;
            if (isValid) {
              _context9.next = 18;
              break;
            }
            reset({
              resetBillId: false
            });
            return _context9.abrupt("return");
          case 18:
            if (!((onBeforePay === null || onBeforePay === void 0 ? void 0 : (_onBeforePay$pendingB = onBeforePay.pendingBill) === null || _onBeforePay$pendingB === void 0 ? void 0 : _onBeforePay$pendingB.needed) === true)) {
              _context9.next = 22;
              break;
            }
            _context9.next = 21;
            return useBeforePayReturns.getPendingBill(_objectSpread(_objectSpread({}, baseReqParams), {}, {
              bizOwnerNo: bizOwnerNo,
              serviceType: productInfo === null || productInfo === void 0 ? void 0 : productInfo.serviceType,
              productLine: productInfo === null || productInfo === void 0 ? void 0 : productInfo.productLine
            }));
          case 21:
            pendingBillData = _context9.sent;
          case 22:
            if (isEmpty(pendingBillData)) {
              _context9.next = 26;
              break;
            }
            _context9.next = 25;
            return useBeforePayReturns.confirmPendingBill(pendingBillData, _objectSpread(_objectSpread({}, baseReqParams), {}, {
              currency: priceCurrencyCode,
              confirmHooks: onBeforePay === null || onBeforePay === void 0 ? void 0 : onBeforePay.pendingBill,
              confirmRender: renderConfirmPendingBill,
              serviceType: productInfo === null || productInfo === void 0 ? void 0 : productInfo.serviceType,
              productLine: productInfo === null || productInfo === void 0 ? void 0 : productInfo.productLine
            }));
          case 25:
            status = _context9.sent;
          case 26:
            // 重置billId
            if (status === EBeforePayStatus.break) {
              reset();
            }

            // 确认结果为 continue 则继续执行支付流程
            if (!(status === EBeforePayStatus.continue)) {
              _context9.next = 51;
              break;
            }
            _context9.next = 30;
            return createSub();
          case 30:
            createSubResult = _context9.sent;
            if (![ECreateSubStatus.FAIL, ECreateSubStatus.BREAK].includes(createSubResult)) {
              _context9.next = 34;
              break;
            }
            setStateAtom(function (draft) {
              draft.payLoading = false;
            });
            return _context9.abrupt("return");
          case 34:
            // 微信
            // ok
            if (radioPayMethod === RadioPayMethod.Wechat) {
              setStateAtom(function (draft) {
                draft.weiXinPayModalVisible = true;
              });
            }

            // fpx
            if (radioPayMethod === RadioPayMethod.FPX) {
              /**
               * 发布FPX结算事件，给到对应的结算组件进行处理
               * 后续其他结算方式也会采取这种方式
               */
              event$ === null || event$ === void 0 ? void 0 : event$.emit({
                type: EEvent.ON_PAY_WITH_FPX,
                payload: {
                  billId: createSubResult
                }
              });
            }

            // 信用卡
            if (radioPayMethod === RadioPayMethod.BindInternationalCard) {
              setStateAtom(function (draft) {
                draft.creditCardPayModalVisible = true;
              });
            }

            // 汇付-银联支付
            if (radioPayMethod === RadioPayMethod.HuifuChannelCasher) {
              handleHuifuPay(createSubResult, curPayMethod, RedirectAction.Open);
            }
            // 汇付-支付宝
            if (radioPayMethod === RadioPayMethod.HuifuAlipay) {
              handleHuifuPay(createSubResult, curPayMethod);
            }
            // 汇付-微信
            if (radioPayMethod === RadioPayMethod.HuifuWechat) {
              // 生成二维码，弹窗展示
              setStateAtom(function (draft) {
                draft.huifuWeiXinModalVisible = true;
              });
            }
            // Airwallex 信用卡
            if (radioPayMethod === RadioPayMethod.Airwallex) {
              setStateAtom(function (draft) {
                draft.creditCardPayModalVisible = true;
              });
            }

            // xendit
            if (radioPayMethod === RadioPayMethod.XENDIT) {
              /**
               * 发布Xendit结算事件，给到对应的结算组件进行处理
               * 后续其他结算方式也会采取这种方式
               *
               * ps: createSubResult 是通过287行附近的createSub完成下单动作所得结果
               */
              event$ === null || event$ === void 0 ? void 0 : event$.emit({
                type: EEvent.ON_PAY_WITH_XENDIT,
                payload: {
                  billId: createSubResult
                }
              });
            }

            // 物流钱包
            if (!(radioPayMethod === RadioPayMethod.OneShip)) {
              _context9.next = 47;
              break;
            }
            if (bizOneShipPay) {
              _context9.next = 46;
              break;
            }
            window.console.error('使用物流钱包支付时，必须传入bizOneShipPay');
            return _context9.abrupt("return");
          case 46:
            bizOneShipPay({
              billId: createSubResult,
              payMethod: curPayMethod
            }).then(function () {
              queryPayChannelStatus(_objectSpread(_objectSpread({}, baseReqParams), {}, {
                billId: createSubResult
              }));
            }).catch(function () {
              setStateAtom(function (draft) {
                draft.payLoading = false;
              });
            });
          case 47:
            // PayNow
            if (radioPayMethod === RadioPayMethod.PayNow) {
              event$ === null || event$ === void 0 ? void 0 : event$.emit({
                type: EEvent.ON_PAY_WITH_PAYNOW,
                payload: {
                  billId: createSubResult
                }
              });
            }

            // UMS
            if (radioPayMethod === RadioPayMethod.BindUnionCard) {
              event$.emit({
                type: EEvent.ON_PAY_WITH_UMS,
                payload: {
                  billId: createSubResult
                }
              });
            }
            // PayPal
            if (curPayMethod === RadioPayMethod.PayPal) {
              // 先调用获取nextAction的接口；
              // 然后，再调用交易sdk的handleNextAction方法完成跳转，看是否需要传递基参过去；
              handlePayPal({
                billIdInRealTime: createSubResult,
                handlePayError: handlePayError
              });
            }

            // 快捷支付
            if (radioPayMethod === RadioPayMethod.BankCard && selectCard !== null && selectCard !== void 0 && selectCard.bindUniqueId) {
              quickPay(createSubResult);
            }
          case 51:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  })));

  // 处理绑卡并支付按钮点击事件
  var onEventPayAndBindClick = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(subscription) {
      var _subscription$payload3;
      var createSubResult, _subscription$payload;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return createSub();
            case 2:
              createSubResult = _context10.sent;
              if (![ECreateSubStatus.FAIL, ECreateSubStatus.BREAK].includes(createSubResult)) {
                _context10.next = 6;
                break;
              }
              subscription === null || subscription === void 0 ? void 0 : (_subscription$payload = subscription.payload) === null || _subscription$payload === void 0 ? void 0 : _subscription$payload.resolver(false);
              return _context10.abrupt("return");
            case 6:
              // 打开/关闭【绑卡并支付】弹窗
              setStateAtom(function (draft) {
                var _subscription$payload2;
                draft.creditCardPayModalVisible = subscription === null || subscription === void 0 ? void 0 : (_subscription$payload2 = subscription.payload) === null || _subscription$payload2 === void 0 ? void 0 : _subscription$payload2.visible;
              });
              subscription === null || subscription === void 0 ? void 0 : (_subscription$payload3 = subscription.payload) === null || _subscription$payload3 === void 0 ? void 0 : _subscription$payload3.resolver(true);
            case 8:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));
    return function onEventPayAndBindClick(_x5) {
      return _ref10.apply(this, arguments);
    };
  }();

  // FPX校验失败事件
  var onEventFPXValidateFail = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              setStateAtom(function (draft) {
                draft.payLoading = false;
              });
            case 1:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));
    return function onEventFPXValidateFail() {
      return _ref11.apply(this, arguments);
    };
  }();
  // Xendit校验失败事件
  var onEventXenditValidateFail = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              setStateAtom(function (draft) {
                draft.payLoading = false;
              });
            case 1:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));
    return function onEventXenditValidateFail() {
      return _ref12.apply(this, arguments);
    };
  }();

  // FPX结算失败事件
  var onEventFPXPayFail = /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(subscription) {
      return _regeneratorRuntime().wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              setStateAtom(function (draft) {
                draft.payLoading = false;
              });
              handlePayError(subscription === null || subscription === void 0 ? void 0 : subscription.payload);
            case 2:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));
    return function onEventFPXPayFail(_x6) {
      return _ref13.apply(this, arguments);
    };
  }();

  // Xendit结算失败事件
  var onEventXenditPayFail = /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(subscription) {
      return _regeneratorRuntime().wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              setStateAtom(function (draft) {
                draft.payLoading = false;
              });
              handlePayError(subscription === null || subscription === void 0 ? void 0 : subscription.payload);
            case 2:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));
    return function onEventXenditPayFail(_x7) {
      return _ref14.apply(this, arguments);
    };
  }();

  // 订阅事件
  event$ === null || event$ === void 0 ? void 0 : event$.useSubscription(function (subscription) {
    var _ref15 = subscription || {},
      type = _ref15.type;

    // 已替换
    // 绑卡并支付按钮点击事件
    if (type === EEvent.ON_PAY_AND_BIND_CLICK) {
      onEventPayAndBindClick(subscription);
    }

    // 对应PayWithFpx 里面会有事件发送到这里
    // FPX校验失败事件
    if (type === EEvent.ON_VALIDATE_FAIL_FPX) {
      onEventFPXValidateFail();
    }

    // FPX结算失败事件
    if (type === EEvent.ON_PAY_FAIL_FPX) {
      onEventFPXPayFail(subscription);
    }

    // xendit校验失败事件
    if (type === EEvent.ON_VALIDATE_FAIL_XENDIT) {
      onEventXenditValidateFail();
    }

    // FPX结算失败事件
    if (type === EEvent.ON_PAY_FAIL_XENDIT) {
      onEventXenditPayFail(subscription);
    }
  });
  return {
    payHandler: payHandler,
    createSub: createSub,
    handlePaySuccess: handlePaySuccess,
    handlePayError: handlePayError,
    handlePayCancel: handlePayCancel
  };
}